import { render, staticRenderFns } from "./PopupTextHeading.vue?vue&type=template&id=00a21cdc&scoped=true"
import script from "./PopupTextHeading.vue?vue&type=script&lang=js"
export * from "./PopupTextHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a21cdc",
  null
  
)

export default component.exports